import {ACTIONS} from "../reducers/filterReducer";

export function openFilter() {
  return {type: ACTIONS.OPEN_FILTER};
}

export function closeFilter() {
  return {type: ACTIONS.CLOSE_FILTER};
}
